import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import * as _ from 'lodash';
import * as styles from './Previews.scss';

var QuestionsPreview = /*#__PURE__*/function (_Component) {
  _inherits(QuestionsPreview, _Component);

  var _super = _createSuper(QuestionsPreview);

  function QuestionsPreview(props) {
    var _this;

    _classCallCheck(this, QuestionsPreview);

    _this = _super.call(this, props);
    var initialState = {};

    _.range(99).forEach(function (i) {
      return initialState["select_".concat(i)] = 0;
    });

    _this.state = initialState;
    return _this;
  }

  _createClass(QuestionsPreview, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var formValues = this.props.formValues;
      var infoQuestions = formValues.infoQuestions.map(function (questionKey, index) {
        return /*#__PURE__*/React.createElement(TextField, {
          key: index,
          hintText: "Enter your answer.",
          floatingLabelText: _.startCase(questionKey),
          floatingLabelFixed: true
        });
      });
      var customQuestions = formValues.customQuestions.map(function (question, customIndex) {
        if (question.type === 'short_answer') {
          return /*#__PURE__*/React.createElement(TextField, {
            key: customIndex,
            hintText: "Enter your answer.",
            floatingLabelText: question.question,
            floatingLabelFixed: true
          });
        } else if (question.type === 'multiple_choice') {
          var options = question.answers.map(function (answer, idx) {
            return /*#__PURE__*/React.createElement(MenuItem, {
              value: idx + 1,
              key: idx,
              primaryText: answer
            });
          });
          return /*#__PURE__*/React.createElement(SelectField, {
            floatingLabelText: question.question,
            value: _this2.state["select_".concat(customIndex)],
            onChange: function onChange(event, index, value) {
              return _this2.setState(_defineProperty({}, "select_".concat(customIndex), value));
            },
            floatingLabelFixed: true
          }, /*#__PURE__*/React.createElement(MenuItem, {
            primaryText: "Select",
            value: 0
          }), options);
        }
      });
      return /*#__PURE__*/React.createElement("div", {
        className: styles.previewWrap
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.headline
      }, formValues.questionsHeadline), customQuestions, infoQuestions);
    }
  }]);

  return QuestionsPreview;
}(Component);

export { QuestionsPreview as default };